<template>
    <div class="login-content-wrapper">
        <template>
            <el-tabs
                v-model="activeTab"
                type="card"
                class="demo-tabs"
                @tab-click="handleClick">
                <el-tab-pane :label="$t('loginText1')" name="tab1">
                    <h6 class="login-text">{{ $t("loginText1") }}</h6>
                    <div class="input-box">
                        <el-input :placeholder="$t('pleaseEnterPhoneMumber')" v-model="formData['username']" type="text" clearable></el-input>
                    </div>
                    <div class="input-box">
                        <el-input :placeholder="$t('pleaseEnterPassword')" v-model="formData['password']" type="password" clearable show-password></el-input>
                    </div>
                    <el-button @click="login_1" class="btn" type="primary">{{ $t("loginText") }}</el-button>
                </el-tab-pane>
                <el-tab-pane :label="$t('loginText2')" name="tab2">
                    <h6 class="login-text">{{ $t("loginText2") }}</h6>
                    <div class="input-box">
                        <el-input :placeholder="$t('pleaseEnterPhoneMumber')" v-model="formData['username']" type="text" clearable></el-input>
                    </div>
                    <div class="input-box">
                        <el-input :placeholder="$t('pleaseEnterPassword')" v-model="formData['password']" type="password" clearable show-password></el-input>
                    </div>
                    <el-button @click="login_2" class="btn" type="primary">{{ $t("loginText") }}</el-button>
                </el-tab-pane>
            </el-tabs>
            <br />
            <div class="footer-links">
                <a href="https://dashboard.nowaittech.com/pages/privacy-policy.html" target="_blank" style="font-size: 14px;">{{ $t("PrivacyPolicy") }}</a>
                <span class="lang-select">
                    <el-button type="text" @click="changeLanguage('EN')">English</el-button>
                    <el-button type="text" @click="changeLanguage('zh-HK')">中文繁體</el-button>
                </span>
            </div>
        </template>
    </div>
</template>
<script>
import {login_company, login_branch} from '@/api'
// import { locale } from 'core-js';
export default {
    data() {
        return {
            activeTab: 'tab1',
            formData: {
                username: '',
                password: ''
            },
            locale: 'EN'
        };
    },
    created() {
        const locale = window.localStorage.getItem('locale') || this.$i18n.locale
        this.locale = locale
        this.$i18n.locale = locale
    },
    methods: {
        changeLanguage(value) {
            this.locale = value
            this.$i18n.locale = value
            window.localStorage.setItem('locale', value)
        },
        login_1() {
            if(this.formData.username && this.formData.password){
                login_company(this.formData).then(res => {
                    if(res.code == 1){
                        console.log('resssssssssssss')
                        console.log(res)
                        window.localStorage.setItem('user', JSON.stringify(this.formData))
                        this.$store.commit('setUserInfo', res.data)
                        window.localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.$store.commit('setAUserInfo', res.authorizelevellist)
                        window.localStorage.setItem('auserinfo', JSON.stringify(res.authorizelevellist))
                        this.$router.push('/');
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }else{
                this.$message({
                    message: this.$t('mobileAndPassword'),
                    type: 'warning'
                })
            }
        },
        login_2() {
            if(this.formData.username && this.formData.password){
                login_branch(this.formData).then(res => {
                    if(res.code == 1){
                        window.localStorage.setItem('user', JSON.stringify(this.formData))
                        this.$store.commit('setUserInfo', res.data)
                        window.localStorage.setItem('userinfo', JSON.stringify(res.data))
                        this.$store.commit('setAUserInfo', res.authorizelevellist)
                        window.localStorage.setItem('auserinfo', JSON.stringify(res.authorizelevellist))
                        this.$router.push('/');
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }else{
                this.$message({
                    message: this.$t('mobileAndPassword'),
                    type: 'warning'
                })
            }
        },
    },
    watch: {
        locale(val) {
            this.$i18n.locale = val
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__nav {
    width: 100%;
}
::v-deep .el-tabs__item {
    width: 50%;
    text-align: center;
}
.login-content-wrapper {
    .login-text {
        font-size: 18px;
        width: 100%;
        text-align: center;
        color: #111827;
    }
    .input-box {
        width: 100%;
        margin: 20px 0;
    }
    .footer-links {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lang-select {
        color: #111827;
    }
    .btn{
        width: 100%;
    }
}
</style>